import { AppShell, Flex } from '@mantine/core';
import { memo, useState } from 'react';
import { useAgenda } from 'src/meeting-agenda/AgendaProvider';
import classes from './Chat.module.css';
import './ChatStylesOverride.css';
import ChatHeader from './components/ChatHeader';
import ChatMessages from './components/ChatMessages';
import ChatSuggestions, { SUGGESTIONS_ACCORDION_KEY } from './components/ChatSuggestions';
import { useChatMessages } from './hooks/useChatMessages';
import { useDragResize } from './hooks/useDragResize';

type ChatProps = {
  width: number;
  onDrag: (newWidth: number) => void;
  onHideChat?: () => void;
  clientId: string | null;
};

function Chat({ onDrag, onHideChat, clientId }: ChatProps) {
  const [expandedAccordionItem, setExpandedAccordionItem] = useState<string | null>(
    SUGGESTIONS_ACCORDION_KEY,
  );
  const { open: openAgendaFlow } = useAgenda();

  const { handleMouseDown } = useDragResize(onDrag);
  const { messages, sendUserMessage, latestIncomingId } = useChatMessages();

  const handleCreateAgenda = () => {
    setExpandedAccordionItem(null);
    openAgendaFlow();
  };

  const handleSendMessage = async (message: string) => {
    setExpandedAccordionItem(null);
    await sendUserMessage(message, clientId);
  };

  return (
    <AppShell.Aside withBorder={false} bg="gray.0" data-testid={'siesta-chat'}>
      <Flex className={classes.curve} align={'flex-end'} justify={'flex-end'}>
        <div
          style={{
            height: '100%',
            width: '100%',
            background: 'var(--mantine-color-gray-0)',
            borderTopLeftRadius: '24px',
          }}
        />
      </Flex>
      <div className={classes.draggable} onMouseDown={handleMouseDown} />
      <ChatHeader onHideChat={onHideChat} />
      <ChatSuggestions
        expandedAccordionItem={expandedAccordionItem}
        setExpandedAccordionItem={setExpandedAccordionItem}
        onCreateAgenda={handleCreateAgenda}
      />

      <ChatMessages
        messages={messages}
        onSendMessage={handleSendMessage}
        latestIncomingId={latestIncomingId}
      />
    </AppShell.Aside>
  );
}

export default memo(Chat);
